import React from "react";
import PagePlaceholder from "../components/PagePlaceholder";

const EstadosFinancierosView = () => (
  <PagePlaceholder title="Estados Financieros" />
);

export default EstadosFinancierosView;
